import { Injectable } from '@angular/core';
import * as encoding from 'encoding-japanese';


@Injectable()
export class CommonService {

  constructor(
  ) { }

  getErrorList(error: any): any[] {
    console.log(error);
    let errorList = [];
    let errorLogList = [];
    if (error === undefined || error === null) {
      errorList.push({ message: '予期せぬエラーが発生しました。' });
      errorLogList.push({ message: '予期せぬエラーが発生しました。(error)' });
    } else {
      try {
        if (error.json() === undefined || error.json() === null) {
          errorList.push({ message: '予期せぬエラーが発生しました。' });
          errorLogList.push({ message: '予期せぬエラーが発生しました。(error.json)' });
        } else if ((error.json())['errors'] === undefined || (error.json())['errors'] == null) {
          errorList.push({ message: '予期せぬエラーが発生しました。' });
          errorLogList.push({ message: '予期せぬエラーが発生しました。(error.json.errors)' });
        } else {
          const errorArray: object[] = (error.json())['errors'];
          errorList.push(errorArray);
        }
      } catch (error2) {
        try {
          errorList.push({ message: error.message });
          errorLogList.push({ message: error.message });
        } catch (error3) {
          errorList.push({ message: '予期せぬエラーが発生しました。' });
        }
      }
    }

    for (var i in errorLogList) {
      console.log(errorLogList[i]);
    }
    return errorList[0];
  }

  getErrorMessage(error: any): string {
    console.log(error);
    let errorMessage = '';
    let errorLog = '';
    if (error === undefined || error === null) {
      errorMessage = '予期せぬエラーが発生しました。';
      errorLog = '予期せぬエラーが発生しました。(error)';
    } else {
      try {
        if (error.json() === undefined || error.json() === null) {
          errorMessage = '予期せぬエラーが発生しました。';
          errorLog = '予期せぬエラーが発生しました。(error.json)';
        } else if ((error.json())['errors'] === undefined || (error.json())['errors'] == null) {
          errorMessage = '予期せぬエラーが発生しました。';
          errorLog = '予期せぬエラーが発生しました。(error.json.errors)';
        } else {
          const errorArray: object[] = (error.json())['errors'];
          for (let i = 0; i < errorArray.length; i++) {
            if (i === 0) {
              errorMessage = errorArray[i]['message'];
            } else {
              errorMessage = errorMessage + ' ' + errorArray[i]['message'];
              // errorMessage = errorMessage + '<br>' + errorArray[i]['message'];
            }
          }
          if (errorMessage.match(/楽観的排他制御/) ) {
            errorMessage = '更新処理が失敗しました。再度、一覧画面の「再取得」をして登録/更新してください。'
          }
        }
      } catch (error2) {
        try {
          errorMessage = error.message;
          if (errorMessage.match(/Unexpected end of JSON input/) ) {
            errorMessage = '通信が切断された可能性があります。再実施してください。'
          }
        } catch (error3) {
          errorMessage = '予期せぬエラーが発生しました。';
        }
      }
    }

    if (errorLog != '') {
      console.log(errorLog);
    }

    return errorMessage;
  }

  getErrorMessageFirst(error: any): string {
    console.log(error);
    let errorMessage = '';
    let errorLog = '';
    if (error === undefined || error === null) {
      errorMessage = '予期せぬエラーが発生しました。';
      errorLog = '予期せぬエラーが発生しました。(error)';
    } else {
      try {
        if (error.json() === undefined || error.json() === null) {
          errorMessage = '予期せぬエラーが発生しました。';
          errorLog = '予期せぬエラーが発生しました。(error.json)';
        } else if ((error.json())['errors'] === undefined || (error.json())['errors'] == null) {
          errorMessage = '予期せぬエラーが発生しました。';
          errorLog = '予期せぬエラーが発生しました。(error.json.errors)';
        } else {
          const errorArray: object[] = (error.json())['errors'];

          if (errorArray.length >= 1) {
            errorMessage = errorArray[0]['message'];
          } else {
            errorMessage = '予期せぬエラーが発生しました。';
            errorLog = '予期せぬエラーが発生しました。(error.json.errors)';
          }
        }
      } catch (error2) {
        try {
          errorMessage = error.message;
        } catch (error3) {
          errorMessage = '予期せぬエラーが発生しました。';
        }
      }
    }

    if (errorMessage.match(/楽観的排他制御/) ) {
      errorMessage = '更新処理が失敗しました。再度、一覧画面の「再取得」をして登録/更新してください。'
    }

    if (errorLog != '') {
      console.log(errorLog);
    }

    return errorMessage;
  }

  //1億配列以上になるとエラーが出るため分割処理追加 2024.12.26
  toSJis(string) {
    // Unicode コードポイントの配列に変換する
    const unicode_array = str_to_unicode_array(string);

    // チャンクサイズを設定
    const chunkSize = 1000000; // 100万要素（適宜調整可能）
    const sjisChunks = [];

    // 配列をチャンクに分割して処理
    for (let i = 0; i < unicode_array.length; i += chunkSize) {
      const chunk = unicode_array.slice(i, i + chunkSize); // 部分配列を切り出す
      const sjisChunk = encoding.convert(chunk, 'SJIS', 'UNICODE'); // S-JIS に変換
      sjisChunks.push(new Uint8Array(sjisChunk)); // TypedArray に変換して保存
    }

    // チャンク配列をそのまま返す（Blobはチャンク配列を直接受け取れるため単一Uint8Arrayへの合成不要）
    return sjisChunks;
  }

  /**
   * 荷主別使用機能マスタの入荷ラベル運用フラグが1(ON)の荷主が存在するか判定
   * @param ownerFunctionsArray セッションストレージの荷主別使用機能マスタのJSON
   * @return boolean 入荷ラベル運用フラグが1(ON)の荷主が1つ以上存在すればtrue
  */
  isCompanyArrivlabeluseFl(ownerFunctionsArray){
    for(let ownerFunction of ownerFunctionsArray){
      if(ownerFunction['arrivlabeluseFl'] == 1){
        return true;
      }
    }
    return false;
  }

  /**
   * 荷主別使用機能マスタの出荷ラベル運用フラグが1(ON)の荷主が存在するか判定
   * @param ownerFunctionsArray セッションストレージの荷主別使用機能マスタのJSON
   * @return boolean 出荷ラベル運用フラグが1(ON)の荷主が1つ以上存在すればtrue
  */
  isCompanyShiplabeluseFl(ownerFunctionsArray){
    for(let ownerFunction of ownerFunctionsArray){
      if(ownerFunction['shiplabeluseFl'] == 1){
        return true;
      }
    }
    return false;
  }

  /**
   * 荷主別使用機能マスタにて、ownerIdの荷主の入荷ラベル運用フラグが1(ON)かを判定
   * @param ownerFunctionsArray セッションストレージの荷主別使用機能マスタのJSON
   * @param ownerId 選択した荷主ID
   * @return boolean ownerIdの荷主の入荷ラベル運用フラグが1(ON)であればtrue
  */
  isArrivlabeluseFl(ownerFunctionsArray, ownerId){
    for(let ownerFunction of ownerFunctionsArray){
      if(ownerFunction['ownerId'] == ownerId){
        if(ownerFunction['arrivlabeluseFl'] == 1){
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 荷主別使用機能マスタにて、ownerIdの荷主の出荷ラベル運用フラグが1(ON)かを判定
   * @param ownerFunctionsArray セッションストレージの荷主別使用機能マスタのJSON
   * @param ownerId 選択した荷主ID
   * @return boolean ownerIdの荷主の出荷ラベル運用フラグが1(ON)であればtrue
  */
  isShiplabeluseFl(ownerFunctionsArray, ownerId){
    for(let ownerFunction of ownerFunctionsArray){
      if(ownerFunction['ownerId'] == ownerId){
        if(ownerFunction['shiplabeluseFl'] == 1){
          return true;
        }
      }
    }
    return false;
  }
}

const str_to_unicode_array = str => {
  if (typeof str === 'string') {
    const arr = [];
    for (let i = 0; i < str.length; i++) {
      arr.push(str.charCodeAt(i));
    }
    return arr;
  } else {
    return str;
  }
};



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/common/common.service.ts